import axios from '@/api/api-request'

const projectUrl = '/testInspectionOrg'

// 管理-查询符合的检测机构列表/搜索机构按钮
export const getInspectionOrgList = (data) => {
  return axios.request({
    url: projectUrl + '/getInspectionOrgList.do',
    method: 'post',
    data: data
  })
}
